import React, { useState, useMemo } from 'react';
import Filters from './Filters';
import './TidesFilterApp.css';

// Import de vos données JSON
import arcachonTides2025 from './data/arcachon-2025.json';
import arcachonTides2026 from './data/arcachon-2026.json';
import capFerretTides2025 from './data/cap-ferret-2025.json';
import capFerretTides2026 from './data/cap-ferret-2026.json';


const arcachonTides   = [...arcachonTides2025, ...arcachonTides2026]
const capFerretTides  = [...capFerretTides2025, ...capFerretTides2026];



function dateToFormatted(d) {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}${month}${day}`;
}

function applyFilters(data, { 
  startDate,
  endDate,
  selectedTideType,
  maxCoefficient,
  weekendOnly,
  startHour,
  endHour
}) {
  let filtered = [...data];

  if (startDate && endDate) {
    const startF = dateToFormatted(startDate);
    const endF = dateToFormatted(endDate);
    filtered = filtered.filter(item => item.formattedDate >= startF && item.formattedDate <= endF);
  }
  if (selectedTideType) {
    filtered = filtered.filter(item => item.type === selectedTideType);
  }
  if (maxCoefficient) {
    const maxVal = parseInt(maxCoefficient, 10);
    filtered = filtered.filter(item => parseInt(item.coefficient, 10) <= maxVal);
  }
  if (weekendOnly) {
    filtered = filtered.filter(item => {
      const wd = item.weekday.toLowerCase();
      return wd === 'samedi' || wd === 'dimanche';
    });
  }
  if (startHour !== null && endHour !== null) {
    filtered = filtered.filter(item => {
      const [hStr] = item.hour.split(':');
      const hour = parseInt(hStr, 10);
      return hour >= startHour && hour <= endHour;
    });
  }
  return filtered;
}

const TidesFilterApp = () => {
  // États pour stocker les données JSON
  const [arcachonDataState] = useState(arcachonTides);
  const [capFerretDataState] = useState(capFerretTides);

  // États des filtres
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate() + 10)));
  const [selectedTideType, setSelectedTideType] = useState('');
  const [maxCoefficient, setMaxCoefficient] = useState('');
  const [weekendOnly, setWeekendOnly] = useState(false);
  // Plage horaire stockée sous forme d'un tableau [startHour, endHour]
  const [timeRange, setTimeRange] = useState([9, 20]);
  const [startHour, endHour] = timeRange;

  // Gestion du changement de la plage de dates
  const handleDateRangeChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  // Affiche marée arcachon et/ou cap ferret
  const [displayArcachon, setDisplayArcachon]   = useState(true);
  const [displayCapFerret, setDisplayCapFerret] = useState(true);


  // Rassemblement des filtres
  const filters = {
    startDate,
    endDate,
    selectedTideType,
    maxCoefficient,
    weekendOnly,
    startHour,
    endHour,
    displayArcachon,
    displayCapFerret
  };

  // Application des filtres aux deux jeux de données
  const filteredArcachon = useMemo(() => applyFilters(arcachonDataState, filters), [arcachonDataState, filters]);
  const filteredCapFerret = useMemo(() => applyFilters(capFerretDataState, filters), [capFerretDataState, filters]);

  return (
    <div className="container">
      <h1 className="header">Est-ce qu'on peut plonger ?</h1>
      
      {/* Composant de recherche / filtres */}
      <Filters 
        startDate={startDate}
        endDate={endDate}
        handleDateRangeChange={handleDateRangeChange}
        selectedTideType={selectedTideType}
        setSelectedTideType={setSelectedTideType}
        maxCoefficient={maxCoefficient}
        setMaxCoefficient={setMaxCoefficient}
        weekendOnly={weekendOnly}
        setWeekendOnly={setWeekendOnly}
        timeRange={timeRange}
        setTimeRange={setTimeRange}
        startHour={startHour}
        endHour={endHour}
        displayArcachon={displayArcachon}
        setDisplayArcachon={setDisplayArcachon}
        displayCapFerret={displayCapFerret}
        setDisplayCapFerret={setDisplayCapFerret}
      />

      {/* Tableaux côte à côte */}
      <div className="tables-container">
        {displayArcachon && (<div className="table-wrapper">
          <h2>Arcachon</h2>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Soleil</th>
                <th>Heure</th>
                <th>Type</th>
                <th>Coeff</th>
                {/*<th>Hauteur</th>*/}
              </tr>
            </thead>
            <tbody>
              {filteredArcachon.map((tide, idx) => (
                <tr key={idx}>
                  <td>{tide.date}</td>
                  <td>{tide.sunrise} - {tide.sunset}</td>
                  <td>{tide.hour}</td>
                  <td>{tide.label}</td>
                  <td>{tide.coefficient}</td>
                  {/*<td>{tide.height}</td>*/}
                </tr>
              ))}
            </tbody>
          </table>
        </div>)}
       {displayCapFerret && ( <div className="table-wrapper">
          <h2>Cap-Ferret</h2>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Soleil</th>
                <th>Heure</th>
                <th>Type</th>
                <th>Coeff</th>
                {/* <th>Hauteur</th> */}
              </tr>
            </thead>
            <tbody>
              {filteredCapFerret.map((tide, idx) => (
                <tr key={idx}>
                  <td>{tide.date}</td>
                   <td>{tide.sunrise} - {tide.sunset}</td>
                  <td>{tide.hour}</td>
                  <td>{tide.label}</td>
                  <td>{tide.coefficient}</td>
                  {/* <td>{tide.height}</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>)}
      </div>
    </div>
  );
};

export default TidesFilterApp;
